<template>
  <div>
    <label title="Specify dates to download samples of">
      Date Range (From-To):
    </label>
    <functional-calendar
        v-model="date_range" :change-month-function='true'
        :change-year-function='true' :is-dark="true"
        :is-date-picker='true' :is-date-range='true' :date-format="'yyyy-mm-dd'"
        :is-layout-expandable="true" :is-modal='true' :is-typeable="true"
        :disabled-dates="disabled_dates" :disabled-day-names="disabled_days"
         @closed="passDateRangeToParent"
    ></functional-calendar>
<!--    :date-format="'yyyy-mm-dd'"-->
  </div>
</template>

<script>
import {FunctionalCalendar} from "vue-functional-calendar";
import moment from "moment";
import EventBus from "@/components/EventBus";

export default {
  name: "DateRangePicker",
  components: {FunctionalCalendar},
  data(){
    return{
      date: new Date(),
      date_range: {},
      from: null,
      to: null,
      disabled_dates: ['afterToday'],
      disabled_days: ['Sa','Su'],
      time_formatter: ' 00:00'
    }
  }, 
  methods: {
    fromToDateSetter() {
      if (this.date_range.dateRange) {
        // format it to be same as backend type of date-time
        this.from = moment(this.date_range.dateRange.start, 'YYYY-MM-DD H:MM')._i + this.time_formatter
        this.to = moment(this.date_range.dateRange.end, 'YYYY-MM-DD H:MM')._i  + this.time_formatter
      } else if (!this.date_range.dateRange) {
        this.from = null;
        this.to = null;
      }
    },

    passDateRangeToParent(){
        this.fromToDateSetter()
        EventBus.$emit('date-range-set', {
          'from': this.from,
          'to': this.to
        })
    }
  }
}
</script>
